<div class="container-fluid">
  <div class="row appLayout">
    <div class="col-12 appLayout__head">
      <app-app-header></app-app-header>
    </div>
    <div class="col-12 appLayout__content">
      <router-outlet />
    </div>
    <div class="col-12 appLayout__footer">
      <app-app-footer></app-app-footer>
    </div>
  </div>
</div>
<app-lets-chat *ngIf="isChatEnabled"></app-lets-chat>

<div
  class="kunnect-widget"
  data-widget-id="67a1422f5217fddb3070bf21"
  style="display: block"></div>
